"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackagingSetAggregationResponse = void 0;
const common_1 = require("../../common");
const packaging_set_aggregation_data_response_1 = require("./packaging-set-aggregation-data.response");
class PackagingSetAggregationResponse extends common_1.PaginatedResponse {
}
exports.PackagingSetAggregationResponse = PackagingSetAggregationResponse;
//# sourceMappingURL=packaging-set-aggregation-search.response.js.map